'use client';

import WebOnly from '@/components/Responsive/WebOnly';
import { LeftArrowOutlined } from '@zeelool/icon';
import './index.scss';

interface SwiperNavigationButtonsProps {
  /** 前一页按钮的CSS类名 */
  prevButtonClass: string;
  /** 下一页按钮的CSS类名 */
  nextButtonClass: string;
  /** 额外的容器CSS类名 */
  containerClassName?: string;
  /** 前一页按钮的额外CSS类名 */
  prevButtonExtraClass?: string;
  /** 下一页按钮的额外CSS类名 */
  nextButtonExtraClass?: string;
}

const SwiperNavigationButtons: React.FC<SwiperNavigationButtonsProps> = ({
  prevButtonClass,
  nextButtonClass,
  containerClassName = '',
  prevButtonExtraClass = '',
  nextButtonExtraClass = '',
}) => {
  return (
    <WebOnly>
      <div
        className={`blog-top-menus-title-btn flex justify-center items-center pr-48 [@media(min-width:1920px)]:hidden ${containerClassName}`}
      >
        <div
          className={`${prevButtonClass} ${prevButtonExtraClass} h-40 w-40 box-border border-1 border-solid border-[#808080] rounded-full flex justify-center items-center cursor-pointer transition-all duration-300 hover:bg-[rgba(128,128,128,0.05)]`}
        >
          <LeftArrowOutlined className="text-16 text-primary-black" />
        </div>
        <div
          className={`${nextButtonClass} ${nextButtonExtraClass} ml-24 h-40 w-40 box-border border-1 border-solid border-[#808080] rounded-full flex justify-center items-center cursor-pointer transition-all duration-300 hover:bg-[rgba(128,128,128,0.05)]`}
        >
          <LeftArrowOutlined className="rotate-180 text-16 text-primary-black" />
        </div>
      </div>
    </WebOnly>
  );
};

export default SwiperNavigationButtons;
